<script setup lang="ts">
const props = defineProps<{
	label: string
	text: string
	imageSrc: string
}>()
</script>

<template>
	<div
		class="energyTip lg:gap:12 relative flex h-[100%] cursor-pointer gap-3 bg-white bg-cover bg-center bg-no-repeat md:gap-6"
		:style="{ backgroundImage: `url(${props.imageSrc})` }"
	>
		<div class="relative w-full pr-2">
			<div
				class="absolute bottom-0 min-w-[300px] transform bg-white px-6 py-4 opacity-90 md:left-[20%] md:w-[61%]"
			>
				<h6 class="mb-4 text-2xl font-bold text-land-red md:text-3xl">{{ label }}</h6>
				<p class="text-base md:text-lg">{{ text }}</p>
			</div>
		</div>
	</div>
</template>
